export var PusherEvent = /*#__PURE__*/ function(PusherEvent) {
    PusherEvent["InvoiceEvent"] = "invoice-event";
    PusherEvent["MailboxUpdated"] = "mailbox-updated";
    PusherEvent["KYCStatusUpdated"] = "kyc-status-updated";
    PusherEvent["PaymentMethod"] = "payment-method";
    PusherEvent["VendorBankAccountConnected"] = "vendor-bank-account";
    PusherEvent["BillingEvent"] = "billing-event";
    PusherEvent["IntegrationEvent"] = "integration-event";
    PusherEvent["ContactUpdated"] = "contact-updated";
    return PusherEvent;
}({});
export var InvoiceEventType = /*#__PURE__*/ function(InvoiceEventType) {
    InvoiceEventType["InvoiceIssued"] = "invoiceIssued";
    InvoiceEventType["QboInvoiceUpdated"] = "qboInvoiceUpdated";
    InvoiceEventType["XeroInvoiceUpdated"] = "xeroInvoiceUpdated";
    return InvoiceEventType;
}({});
export var BillEventType = /*#__PURE__*/ function(BillEventType) {
    BillEventType["CsvBulkBillFinished"] = "csvBulkBillFinished";
    return BillEventType;
}({});
export var PaymentMethodEventType = /*#__PURE__*/ function(PaymentMethodEventType) {
    PaymentMethodEventType["PaymentMethodAdded"] = "paymentMethodAdded";
    PaymentMethodEventType["PaymentMethodUpdated"] = "paymentMethodUpdated";
    PaymentMethodEventType["FailedToAddPaymentMethod"] = "failedToAddPaymentMethod";
    PaymentMethodEventType["VendorBankAccountConnected"] = "vendorBankAccountConnected";
    PaymentMethodEventType["VendorBankAccountConnectionFailed"] = "vendorBankAccountConnectionFailed";
    return PaymentMethodEventType;
}({});
export var IntegrationEventType = /*#__PURE__*/ function(IntegrationEventType) {
    IntegrationEventType["IntegrationXeroReady"] = "integrationXeroReady";
    return IntegrationEventType;
}({});
export var ContactUpdatedType = /*#__PURE__*/ function(ContactUpdatedType) {
    ContactUpdatedType["ContactEmailUpdated"] = "contactEmailUpdated";
    return ContactUpdatedType;
}({});
